import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDisplayText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly);
